import React, { ChangeEvent, useState } from "react";
import styles from "./bulkInfoVideos.module.css";
import { Field, Form, Formik, FormikProps } from "formik";
import { Buttons } from "../../components";
import { errorNotification, successNotification } from "./utils";
import { ActivityIndicator } from "../../components/ActivityIndicator";
import useBulkInfoVideos from "../../api/useBulkInfoVideos";

const BulkInfoVideos = () => {
  const [initialValues, setInitialValues] = useState({
    link: "",
  });
  const [loading, setLoading] = useState(false);
  const bulkInfoVideos = useBulkInfoVideos();

  const handleSubmit = async (formValues: any) => {
    setLoading(true);
    try {
      const response = await bulkInfoVideos({
        sheetUrl: formValues.link,
      });

      response.data && successNotification();
      setLoading(false);
    } catch (error) {
      console.log({ error });
      setLoading(false);
      errorNotification();
    }
  };

  if (loading) {
    return <ActivityIndicator />;
  }

  return (
    <div className={styles.container}>
      <h1>Bulk Info Videos</h1>
      <div className={styles.lessonsContent}></div>
      <div className={styles.inputGenerate}>
        <Formik
          enableReinitialize
          onSubmit={handleSubmit}
          initialValues={initialValues}
        >
          {({ errors, handleReset, touched }: FormikProps<any>) => {
            return (
              <Form className={styles.formContainer}>
                <label htmlFor="">Ingrese el link de spreadsheet</label>
                <Field
                  errors={errors}
                  touched={touched}
                  value={initialValues.link}
                  className={styles.formFields}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setInitialValues({
                      ...initialValues,
                      link: e.target.value,
                    });
                  }}
                  name="link"
                  title="Link"
                  type="text"
                />

                <Buttons
                  handleClick={() => {
                    handleReset();
                  }}
                />
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default BulkInfoVideos;
